import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eznxtx44ut: FaireBrandEntity = {
  token: "b_eznxtx44ut",
  type: "brand",
  name: "The Sacred Essence",
  avatarUrl:
    "https://cdn.faire.com/fastly/cf32e4a344e18a56e8a209ecbfc02d96ea2be0b6fc480b9b35482714d7dbae3c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f93a81ee1667e6fff3c28873354d640c6efd4ebe3e0b058ac1403defad25e4d0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cf32e4a344e18a56e8a209ecbfc02d96ea2be0b6fc480b9b35482714d7dbae3c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f93a81ee1667e6fff3c28873354d640c6efd4ebe3e0b058ac1403defad25e4d0.png",
  location: "Kihei , HI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: false,
  description:
    "Sacred Essence mission is to awaken and rise human consciousness into Oneness by returning to our Angelic origin, first energetically, then physically by creating 5th Dimensional Earth. We can do this by detoxifying, purifying, and re-awakening our body to self-healing, by doing the inner work, and expanding our consciousness and vibration.\n\nSacred Essence creates 100% natural, pure, high-frequency products that are effective and charged with Divine Love. \n\nWe are sending much LOVE, LIGHT, and many Blessings to YOU. \n\nEnjoy.\n\nShaktiRA\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:49.614Z",
    importedBy: "entity-db-cli",
  },
};
